// extracted by mini-css-extract-plugin
export default {"storeNameInput":"AzxXio"};